import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { MipAnalysisListScreen } from "./MipAnalysisListScreen";
import { MipSessionsListScreen } from "./MipSessionsListScreen";
import { MipAnalysisScreen } from "./MipAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const MipRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/Mip" exact permissions={[PermissionEnum.AccessSingleMipSession, PermissionEnum.AccessAllMipSessions, PermissionEnum.OverreadMipSession]}>
                <MipSessionsListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Mip/Analysis" exact permissions={[PermissionEnum.OverreadMipSession]}>
                <MipAnalysisListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Mip/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadMipSession, PermissionEnum.AccessSingleMipSession]}>
                <MipAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
